module.exports = __webpack_public_path__ + "img/PP_Sword_1039.dd87d7b0.png";